import React from "react";
import { DelegateRole, Permission } from "types";
import { useUser } from "../hooks/useAccount";
import { useAuthorization } from "../hooks/useAuthorization";
import { hasRole } from "../models/User";
import { DashboardPage } from "./DashboardPage";
import { CouponPage } from "./Marketing/CouponPage";
import { ExperienceListPage } from "./Product/ExperienceListPage";
import { MerchandiseListPage } from "./Product/MerchandiseListPage";
import { PurchaseItemPage } from "./PurchaseItemPage";
import { AnalyticsPage } from "./Reports/AnalyticsPage";

export const HomePage = () => {
    const { isGranted } = useAuthorization();
    const user = useUser();

    return isGranted(Permission.DASHBOARD_VIEW) ? (
        <DashboardPage />
    ) : isGranted(Permission.MARKETER_HOME_VIEW) && !isGranted(Permission.PRODUCTS_VIEW) ? (
        <CouponPage />
    ) : isGranted(Permission.REPORTS_ANALYTICS_VIEW) && hasRole(user, DelegateRole.ACCOUNTANT) ? (
        <AnalyticsPage />
    ) : isGranted(Permission.PRODUCT_CATALOG_VIEW) ? (
        <ExperienceListPage />
    ) : isGranted(Permission.PRODUCTS_VIEW) && hasRole(user, DelegateRole.WARE_MANAGER) ? (
        <MerchandiseListPage />
    ) : isGranted(Permission.PURCHASES_VIEW) ? (
        <PurchaseItemPage />
    ) : (
        /**
         * Temporary home as we don't have all the views yet.
         * TODO: Arathi: Add homepages for other roles, homepage is Transactions for ROLE_ACCOUNTANT, Experience listing for curator
         */
        <DashboardPage />
    );
};
